/* react-refetch funktioniert nur dann, wenn es das notwendige Token mit
 * schickt. Dafür gibt es diese Erweiterung.
 */
import { connect } from "react-refetch";

import { getAuthToken } from "../model/Benutzer";

const cache = new Map();

const cachingFetchWithToken = (input, init) => {
	const req = new Request(input, init);
	/*const now = new Date().getTime();
	const inAMinute = 60 * 1000 + now;*/
	const cached = cache.get(req.url);

	if (cached /*&& cached.time < inAMinute*/) {
		return Promise.resolve(cached.response.clone());
	}

	return fetch(req, {	headers: {
		"Authorization": "Bearer " + getAuthToken()
	}}).then(response => {
		cache.set(req.url, {
			/*time: now,*/
			response: response.clone()
		});
		return response;
	});
};

export const cachingRefetchWithToken = connect.defaults({
	fetch: cachingFetchWithToken
});
